import * as React                                   from "react";
import { ReactNode }                                from "react";
import { connect }                                  from "react-redux";
import { Dispatch }                                 from "redux";
import { Tab }                                      from "semantic-ui-react";
import GetFacilities                                from "../../../application/usecase/facility/GetFacilities";
import DeleteReservationSpecialTime
                                                    from "../../../application/usecase/reservation/DeleteReservationSpecialTime";
import GetReservationSetting
                                                    from "../../../application/usecase/reservation/GetReservationSetting";
import SaveReservationSetting
                                                    from "../../../application/usecase/reservation/SaveReservationSetting";
import MenuType                                     from "../../../domain/menu/MenuType";
import ReservationSetting                           from "../../../domain/reservation/ReservationSetting";
import { ReservationSettingRepository }             from "../../../domain/reservation/ReservationSettingRepository";
import { ResKaState }                               from "../../../index";
import ReservationSettingDataSource
                                                    from "../../../infrastructure/datasource/reservation/ReservationSettingDataSource";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import RightPositionSection                         from "../../components/common/layout/RightPositionSection";
import TopSection                                   from "../../components/common/layout/TopSection";
import OfficeSelector                               from "../../components/common/OfficeSelector";
import ReservationFacilityList                      from "../../components/setting/reservation/ReservationFacilityList";
import ReservationTimeSetting                       from "../../components/setting/reservation/ReservationTimeSetting";
import ReservationUrlTab                            from "../../components/setting/reservation/url/ReservationUrlTab";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  reservationSetting: ReservationSetting;
  repository: ReservationSettingRepository;
  getReservationSetting: GetReservationSetting;
  saveReservationSetting: SaveReservationSetting;
  deleteReservationSpecialTime: DeleteReservationSpecialTime;
  getFacilities: GetFacilities;
}

class ReservationSettingContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state = {
      menuType: MenuType.SETTING,
      headerTitle: "予約設定"
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
    this.props.getReservationSetting.execute();
    this.props.getFacilities.execute();
  }

  protected renderInternal(): ReactNode {
    const {reservationSetting, repository, saveReservationSetting, deleteReservationSpecialTime} = this.props;
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "設定",
                path: "/setting"
              },
              {
                title: "予約設定",
                path: "/reservation/setting"
              },
            ]
          }/>
          <RightPositionSection>
            <OfficeSelector/>
          </RightPositionSection>
        </TopSection>

        <TopSection>
          <BackHistoryButton path="/setting"/>
        </TopSection>

        <p>予約管理で使う設定を行います。</p>
        <Tab renderActiveOnly={ true } panes={
          [
            {
              menuItem: "営業日・営業時間",
              render: () => (
                <Tab.Pane>
                  <ReservationTimeSetting
                    reservationSetting={ reservationSetting }
                    repository={ repository }
                    saveReservationSetting={ saveReservationSetting }
                    deleteReservationSpecialTime={ deleteReservationSpecialTime }
                  />
                </Tab.Pane>
              )
            },
            {
              menuItem: "予約対象施設・設備",
              render: () => (
                <Tab.Pane>
                  <ReservationFacilityList/>
                </Tab.Pane>
              )
            },
            {
              menuItem: "WEB予約設定",
              render: () => (
                <Tab.Pane>
                  <ReservationUrlTab/>
                </Tab.Pane>
              )
            }
          ]
        }/>
      </>
    );
  }
}

const mapStateToProps = (state: ResKaState) => ({
  reservationSetting: state.reservationSetting,
  fetchStatus: state.fetchStatus,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getReservationSetting: new GetReservationSetting(dispatch),
  repository: new ReservationSettingDataSource(dispatch),
  saveReservationSetting: new SaveReservationSetting(dispatch),
  deleteReservationSpecialTime: new DeleteReservationSpecialTime(dispatch),
  getFacilities: new GetFacilities(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReservationSettingContainer);
